import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tool_tip" }

import { ref, onUnmounted } from "vue";
import { createPopper, type Instance } from "@popperjs/core";

import { type TooltipProps } from "@/types";


export default /*@__PURE__*/_defineComponent({
  __name: 'ToolTip',
  props: {
    labelIcon: { type: [String, Object, Function, null] },
    text: {},
    maxWidth: {},
    bgColor: {},
    color: {},
    placement: {}
  },
  setup(__props: any) {

const props = __props;

// Refs for DOM nodes
const icon = ref<HTMLElement | null>(null);
const tooltip = ref<HTMLElement | null>(null);

// Popper instance
let popperInstance: Instance | null = null;

const createInstance = () => {
  if (icon.value && tooltip.value) {
    popperInstance = createPopper(icon.value, tooltip.value, {
      placement: props.placement ?? "top",
      modifiers: [
        {
          name: "offset",
          options: {
            offset: [0, 10],
          },
        },
        {
          name: "flip",
          options: {
            fallbackPlacements: ["top", "bottom"],
          },
        },
        {
          name: "preventOverflow",
          options: {
            padding: 10,
          },
        },
      ],
      strategy: "absolute",
    });
  }
};

const handleShow = () => {
  if (!popperInstance) createInstance();
  tooltip.value?.setAttribute("data-show", "");
  popperInstance?.update();
};

const handleHide = () => {
  tooltip.value?.removeAttribute("data-show");
};

onUnmounted(() => {
  popperInstance?.destroy();
  popperInstance = null;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
      "aria-describedby": "tool_tip",
      onMouseenter: handleShow,
      onMouseleave: handleHide,
      onFocus: handleShow,
      onBlur: handleHide,
      ref_key: "icon",
      ref: icon
    }, [
      (__props.labelIcon)
        ? (_openBlock(), _createBlock(_resolveDynamicComponent(__props.labelIcon), { key: 0 }))
        : _createCommentVNode("", true)
    ], 544),
    _createElementVNode("div", {
      ref_key: "tooltip",
      ref: tooltip,
      class: "tooltipText",
      role: "tooltip",
      style: _normalizeStyle({ maxWidth: __props.maxWidth, backgroundColor: __props.bgColor, color: __props.color })
    }, [
      _createTextVNode(_toDisplayString(__props.text) + " ", 1),
      _cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "tooltipArrow",
        "data-popper-arrow": ""
      }, null, -1))
    ], 4)
  ]))
}
}

})